import SPIN from './model';
import Activity from '../Activity';
import { Map } from 'immutable';

const reviver = ([key, val]) => {
  switch (key) {
    case 'studentActivities':
      return [key, val.reduce((map, item) => map.set(`${item.studentId}`,
          Activity.create(item)), Map())];
    default:
      return [key, val];
  }
};

const create = (data) => new SPIN(data).mapEntries(reviver);

export default create;




// WEBPACK FOOTER //
// ./data/WritingAssignment/SPIN/create.js